import { createContext, useContext } from "react";

const EditorContext = createContext()

export function EditorProvider({ children, value }) {

    return (
        <EditorContext.Provider value={value}>
            {children}
        </EditorContext.Provider>
    )
}

export function useEditor() {
    const context = useContext(EditorContext);
    if(!context) {
        throw new Error ('useEditor must be used within an EditorProvider');
    }
    return context;
}
